<template>
  <div>
    <botao-remanejar class="mb-3" servico="referenciamentos" :registro="item" @remanejado="$router.go(-1)" />
    <h1 class="h3 mb-3 text-gray-800">Detalhes da {{ item.tipo_nome }}</h1>

    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />

    <div class="row" v-if="historicoStatus == false">
      <ModalVerificarPrivado
        :familia-id="item.familia_id"
        v-if="item.privado == 1 && status_privado == false"
        @liberar="status_privado = true"
      />
      <div
        v-else
        class="col-md-12"
        v-on:mousemove="status_privado = !checkInactivity"
      >
        <print-content>
          <table
            class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
          >
            <tbody>
              <tr>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ item.cadastrado }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.atualizado }}</strong>
                </td>
                <td>
                  STATUS:
                  <b v-html="item.status_nome"></b>
                </td>
              </tr>
              <tr>
                <td colspan="2">TIPO: <b v-html="item.tipo_nome"></b></td>
                <td colspan="2">
                  FAMÍLIA:
                  <b-link v-b-tooltip.hover title="Ver o prontuário da família">
                    #{{ item.familia_id }}
                    <i class="fas fa-external-link-alt"></i>
                  </b-link>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  USUÁRIO(S) ATENDIDO(S):
                  <strong
                    class="mr-2"
                    v-for="(pessoa, index) in item.pessoas_objetos"
                    :key="pessoa.id"
                  >
                    {{ pessoa.nome_completo }} -
                    {{ pessoa.data_nascimento | calcIdade }}
                    ano(s)
                    <span v-if="index < item.pessoas_objetos.length - 1"
                      >,</span
                    >
                  </strong>
                </td>
              </tr>
              <tr>
                <td >
                  TÉCNICO RESPONSÁVEL: <b v-if="item.user">{{
                    item.user.name
                  }}</b>
                </td>
                <td colspan="2">TÉCNICO AUTOR: <b>{{ item.autor }}</b></td>
                <td>
                  UNIDADE DE ORIGEM:
                  <b v-if="item.unidade">{{ item.unidade.nome }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  UNIDADE DE INTERVENÇÃO:
                  <b v-if="item.unidade_destino">{{
                    item.unidade_destino.nome
                  }}</b>
                </td>
                <td colspan="2">
                  TÉCNICO NA UNIDADE DE INTERVENÇÃO:
                  <b v-if="item.user_destino">{{ item.user_destino.name }}</b>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  SITUAÇÃO IDENTIFICADA:
                  <div v-html="item.situacao_identificada"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <span v-if="item.devolutiva && item.devolutiva != ''">
            <table
              class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
            >
              <tbody>
                <tr>
                  <td colspan="4" class="text-center">DEVOLUTIVA</td>
                </tr>
                <tr>
                  <td colspan="2">
                    TÉCNICO NA UNIDADE DE INTERVENÇÃO:
                    <b v-if="item.devolutiva.referencia">{{
                      item.devolutiva.referencia.user_destino.name
                    }}</b>
                  </td>
                  <td colspan="2">
                    DATA DE CADASTRO:
                    <b>{{ item.devolutiva.created_at }}</b>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    INTERVENÇÕES REALIZADAS:
                    <div v-html="item.devolutiva.intervencoes_realizadas"></div>
                  </td>
                </tr>

                <tr>
                  <td colspan="4">
                    AVALIAÇÃO DA EQUIPE SOBRE A SUPERAÇÃO DAS PROBLEMÁTICAS
                    ENCAMINHADAS:
                    <div v-html="item.devolutiva.avaliacao_superacao"></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </span>

          <print-footer 
            v-if=" item.user.tecnico.assinatura_digital" 
            :tecnico="item.user.tecnico" 
            class="mt-0" 
            :assinatura=" item.user.tecnico.assinatura_digital"
            :wpp="wpp"
            :email="email"
          /> 

          <p class="text-muted">{{ app_cidade }}, {{ app_data_atual }}</p>

          <div class="row pt-4 px-0 d-flex justify-content-end no-print">
            <div class="col-auto px-2 text-right">
              <form-toggle
                  grid="12"
                  mt="0"
                  v-model="email"
                  label="Email"
              />
              <form-toggle
                  grid="12"
                  mt="0"
                  v-model="wpp"
                  label="Telefone/WhatsApp"
              />
              <a
                class="router-link-exact-active active px-3"
                @click="historicoStatus = true"
              >
                <i class="fas fa-history"></i> Histórico de Status
              </a>

              <b-link
                class="btn btn-default"
                :to="
                  '/dashboard/referenciamentos/' +
                  item.familia_id +
                  '?familia_id=' +
                  item.familia_id
                "
              >
                <i class="mdi mdi-arrow-left" />
              </b-link>
              <span v-if="item.status != statusInativo[0].id">
                <span
                  v-if="
                    statusAnterior != statusAndamento[0].id &&
                    item.devolutiva == ''
                  "
                >
                  <a
                    class="btn btn-danger"
                    @click="
                      $bvModal.show('status-historico-' + model);
                      statusAtual = statusInativo[0].id;
                    "
                    v-if="
                      user_id == item.user_id &&
                      item.status != statusInativo[0].id
                    "
                  >
                    <i class="fas fa-archive"></i> Arquivar
                  </a>

                  <b-link
                    class="btn btn-info"
                    @click="
                      $bvModal.show('status-historico-' + model);
                      statusAtual = statusAndamento[0].id;
                    "
                    v-if="
                      (item.status != statusInativo[0].id &&
                        item.unidade_destino_id == unidade_id) ||
                      item.user_destino_id == tecnico_id
                    "
                  >
                    Atualizar para <b>Em Andamento</b>?
                  </b-link>
                </span>
                <span v-if="item.devolutiva == ''">
                  <b-link
                    class="btn btn-success"
                    :to="
                      '/dashboard/referenciamentos/show/' +
                      item.id +
                      '/devolutiva'
                    "
                    v-if="
                      (item.status != statusInativo[0].id &&
                        item.unidade_destino_id == unidade_id) ||
                      item.user_destino_id == tecnico_id
                    "
                  >
                    <i class="fas fa-reply"></i> Cadastrar Devolutiva
                  </b-link>
                </span>
              </span>
              <a class="btn btn-primary" @click="print()">
                <i class="mdi mdi-printer" />
              </a>
            </div>
          </div>
            
        </print-content>
      </div>
    </div>

    <div class="row animate__animated animate__fadeIn" v-else>
      <div class="col-12"></div>
      <HistoricoStatus
        @voltar="historicoStatus = false"
        :id="item.id"
        :familia="item.familia_id"
        :status="status_item"
      />
    </div>

    <span
      v-if="
        item.devolutiva && item.devolutiva != '' && historicoStatus == false
      "
    >
      <div v-if="item.devolutiva.anexos && item.devolutiva.anexos.length > 0">
        <h4>Documentos Anexados na Devolutiva</h4>
        <anexos :anexos="item.devolutiva.anexos" />
      </div>
    </span>

    <div
      v-if="item.anexos && item.anexos.length > 0 && historicoStatus == false"
    >
      <anexos :anexos="item.anexos" />
    </div>
    <span v-if="item.privado == 1 && status_privado == false">
      Referência/Contrarreferência com informações sigilosas.
    </span>
    <span v-else>
      <modulo-comentario
        v-if="item.id && historicoStatus == false"
        module="Referencia"
        :id="item.id"
      />
    </span>

    <status-historico
      v-if="status"
      :model="model"
      modulo="Referencia"
      titulo_modulo="REFERÊNCIA/CONTRARREFERÊNCIA"
      :id="item.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_item"
      @submit="submit"
    />
  </div>
</template>
<script>
import HistoricoStatus from "./HistoricoStatus";
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
export default {
  name: "Show",
  components: {
    HistoricoStatus,
    ModalVerificarPrivado,
  },
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      servicos: [],
      unidades: [],
      user_id: this.$store.state.user.id,
      tecnico_id: null,
      unidade_id: null,
      statusAtual: "",
      statusAnterior: "",
      status: {},
      status_item: [],
      model: "Referencia",
      statusInativo: [{}],
      statusAndamento: [{}],
      historicoStatus: false,
      status_privado: false,
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getStatus();
    this.getItem();
    this.getStatusFinais();
  },
  computed: {
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-privado");
      }
      return this.$root.isIdle;
    },
  },
  methods: {
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/referenciamentos/${this.$route.params.id}`)
        .then((response) => {
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.item = response.data.data;
          this.statusAnterior = this.item.status;
          this.unidade_id = this.$store.state.user.unidade.id;
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html:
              "A Referência/Contrarreferência não foi carregada corretamente<br>" +
              error,
            icon: "error",
          });

          this.$router.push(
            "/dashboard/referenciamentos/" + parseInt(error.split("#")[1])
          );
        });
    },
    getStatus() {
      axios.get(`api/dashboard/status/referenciamentos`).then((response) => {
        this.status = response.data;

        this.statusInativo = this.status.filter((item) => {
          return item.value == "INATIVO";
        });
        this.statusAndamento = this.status.filter((item) => {
          return item.value == "EM ANDAMENTO";
        });
      });
    },
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: this.model,
          module: this.model,
        })
        .then((response) => {
          this.status_item = response.data;
        });
    },
    verificarValueArray(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    submit() {
      var item = {
        id: this.item.id,
        status: this.statusAtual,
        user_destino_id: this.tecnico_id,
      };
      axios
        .post(`api/dashboard/update/referenciamento`, item)
        .then((response) => {
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.getItem();
        });
    },
    checkInactivityMoveMouse() {
      if (this.item.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
  },
};
</script>
